import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useAddBlockForm} from '../../model';

interface AddBlockModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AddBlockModal = ({open, setOpen}: AddBlockModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useAddBlockForm({setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Блок',
    title: 'Ошибка при добавлении блока',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Очистка формы при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Добавить блок'}
        textButtonApply={'Добавить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Заголовок блока"
          placeholder="Заголовок блока"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />
        <FormInput
          label="Название блока"
          placeholder="Название блока"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.name && errors.name}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
